import React from "react";
import { Button, Paper } from "@mui/material";
import { clearAudienceCookies, getConsent, setConsent } from "../../utils/consent";
import { InitializeGoogleAnalytics } from "../../GA";
import { InitializeHotjar } from "../../Hotjar";

export default class CookieConsentBanner extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: getConsent() === null,
    };
    this.open = this.open.bind(this);
  }

  componentDidMount() {
    window.addEventListener("openCookieConsent", this.open);
  }

  componentWillUnmount() {
    window.removeEventListener("openCookieConsent", this.open);
  }

  open() {
    this.setState({ visible: true });
  }

  accept() {
    setConsent(true);
    InitializeGoogleAnalytics();
    InitializeHotjar();
    this.setState({ visible: false });
  }

  refuse() {
    setConsent(false);
    clearAudienceCookies();
    this.setState({ visible: false });
  }

  render() {
    if (!this.state.visible) return null;

    return (
      <Paper
        elevation={4}
        style={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2000,
          padding: 16,
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <p style={{ margin: 0, fontSize: 14, flex: "1 1 320px" }}>
          Nous utilisons des cookies de mesure d'audience (Google Analytics)
          et d'analyse du comportement (Hotjar) pour améliorer le site. Ils ne
          sont déposés qu'avec votre accord.
        </p>
        <div style={{ display: "flex", gap: 8 }}>
          <Button
            variant={"outlined"}
            onClick={() => {
              this.refuse();
            }}
          >
            Refuser
          </Button>
          <Button
            variant={"contained"}
            onClick={() => {
              this.accept();
            }}
          >
            Accepter
          </Button>
        </div>
      </Paper>
    );
  }
}
